module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  _(locals.fields).each(function(options, name, list) { 
    ; __append(" <div class=\"form-group\"> ")
    ;  if (options.type != 'hidden') { 
    ; __append(" <label for=\"")
    ; __append(escapeFn( options.labelName ))
    ; __append("\" class=\"col-sm-4 control-label\">")
    ; __append(escapeFn( options.label ))
    ; __append("</label> ")
    ;  } 
    ; __append(" <div class=\"col-sm-8\"> ")
    ;  if (options.type == 'checkbox') { 
    ; __append(" <input name=\"")
    ; __append(escapeFn( options.labelName ))
    ; __append("\" id=\"")
    ; __append(escapeFn( options.labelName ))
    ; __append("\" type=\"")
    ; __append(escapeFn( options.type ))
    ; __append("\" ")
    ; __append(escapeFn( options.value == '1' ? 'checked="checked"' : '' ))
    ; __append("> ")
    ;  } else { 
    ; __append(" <input name=\"")
    ; __append(escapeFn( options.labelName ))
    ; __append("\" class=\"form-control\" id=\"")
    ; __append(escapeFn( options.labelName ))
    ; __append("\" type=\"")
    ; __append(escapeFn( options.type ))
    ; __append("\" value=\"")
    ; __append(escapeFn( options.value ))
    ; __append("\"> ")
    ;  } 
    ; __append(" </div> </div> ")
    ;  }); 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/credential_management.ejs
// module id = 844
// module chunks = 1